// src/components/Services/Services.js
import React from 'react';
import { Link } from 'react-router-dom'; // Sayfalar arası akıllı geçiş için Link'i import ettik
import './Services.css';

// React Icons kütüphanesinden kartlara da lüks ikonlar ekleyelim
import { 
  FiShield, 
  FiHeart, 
  FiBriefcase, 
  FiUsers, 
  FiFileText, 
  FiHome 
} from 'react-icons/fi';

function Services() {
  // Kartların hem URL adını (path/id) hem de lüks ikonlarını ekledik
  const servicesData = [
    { id: 'ceza-hukuku', title: 'Ceza Hukuku', desc: 'Soruşturma ve kovuşturma aşamalarında müvekkillerimizin haklarını titizlikle savunuyoruz.', icon: <FiShield /> },
    { id: 'aile-hukuku', title: 'Aile ve Boşanma Hukuku', desc: 'Boşanma, nafaka, velayet ve mal paylaşımı süreçlerinde gizlilik odaklı hukuki danışmanlık.', icon: <FiHeart /> },
    { id: 'ticaret-hukuku', title: 'Şirketler ve Ticaret Hukuku', desc: 'Şirket kuruluşları, ticari sözleşmeler ve ortaklık uyuşmazlıklarında profesyonel destek.', icon: <FiBriefcase /> },
    { id: 'is-hukuku', title: 'İş ve Sosyal Güvenlik Hukuku', desc: 'İşçi-işveren uyuşmazlıkları, işe iade davaları ve kıdem/ihbar tazminatı süreçleri.', icon: <FiUsers /> },
    { id: 'icra-hukuku', title: 'İcra ve İflas Hukuku', desc: 'Alacakların hızlı ve etkili tahsili, haciz işlemleri ve iflas süreçlerinin yönetimi.', icon: <FiFileText /> },
    { id: 'gayrimenkul-hukuku', title: 'Gayrimenkul Hukuku', desc: 'Tapu iptal, tescil, kira uyuşmazlıkları ve tahliye davalarında hukuki çözüm ortaklığı.', icon: <FiHome /> },
  ];

  return (
    <section className="services-section">
      <div className="container">
        
        {/* Bölüm Başlığı */}
        <div className="section-header">
          <h2 className="section-title">Çalışma <span className="gold-text">Alanlarımız</span></h2>
          <div className="title-underline"></div>
        </div>

        {/* Kartların Listelendiği Grid Alanı */}
        <div className="services-grid">
          {servicesData.map((service) => (
            <div key={service.id} className="service-card">
              <div className="card-icon">{service.icon}</div>
              <h3 className="card-title">{service.title}</h3>
              <p className="card-desc">{service.desc}</p>
              
              {/* HTML a etiketi yerine react-router-dom Link bileşeniyle dinamik yönlendirme */}
              <Link to={`/calisma-alanlari/${service.id}`} className="card-link">
                Detaylı Bilgi &rarr;
              </Link>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Services;